import {
    LOADING_PROCCESS,
} from '../actions/types';

let loadingsCount = 0;
const INITIAL_STATE = false;

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOADING_PROCCESS:
            if (action.meta && action.meta.preventLoading) {
                return state;
            }
            loadingsCount += (action.payload ? 1 : -1);
            return loadingsCount > 0;
        default:
            return state;
    }
};
